module.exports = __webpack_public_path__ + "static/media/instalogo.f7f657b1.png";